import React from "react";


export default function TopNavbar() {

    return (          
                <>
                    <div className="text-right flex space-x-8 bg-sky-800">
                        <img src="../assets/icons/icons8-person-64.png" class="h-14 " alt="" />
                        <span className="block  font-semibold text-white">Ro Schwartz</span>
                        <div className="flex-grow font-semibold text-white">Logout </div>
                    </div>
                   
                </>       
    );
}